import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/collaterals";
import {
  GET_COLLATERALS_REQUESTED,
  GET_COLLATERALS_FAILED,
  GET_INVOICE_COLLATERAL_REPORT_REQUESTED,
  GET_INVOICE_COLLATERAL_REPORT_FAILED,
} from "../types";
import moment from "moment";

function* watchGetCollaterals() {
  yield takeEvery(GET_COLLATERALS_REQUESTED, getCollaterals);
}

function* watchGetInvoiceCollateralReport() {
  yield takeEvery(
    GET_INVOICE_COLLATERAL_REPORT_REQUESTED,
    getInvoiceCollateralReport
  );
}

function* getCollaterals(action) {
  try {
    const resp = yield call(apiGetCollateral, action.payload);
    const items = resp.data.items;
    yield put(
      actions.getCollateralSucceeded({
        items,
        total: {
          totalItemCount: resp.data.totalItemCount,
          totalPageCount: resp.data.totalPageCount,
        },
      })
    );
  } catch (err) {
    yield put(actions.getCollateralFailed());
  }
}

function* getInvoiceCollateralReport(action) {
  try {
    const resp = yield call(apiGetInvoiceCollateralReport, action.payload);

    const items = resp?.data?.invoiceAssuranceResponseDetailListDto;
    yield put(
      actions.getInvoiceCollateralReportSucceeded({
        items,
        total: {
          totalItemCount: resp?.data?.totalElement,
          totalPageCount: resp?.data?.totalPage,
        },
      })
    );
  } catch (err) {
    yield put(actions.getInvoiceCollateralReportFailed());
  }
}

function* watchGetCanceledCollaterals() {
  yield takeEvery(GET_COLLATERALS_FAILED, getCanceledCollaterals);
  yield takeEvery(GET_INVOICE_COLLATERAL_REPORT_FAILED, getInvoiceCollateral);
}

function* getCanceledCollaterals(action) {
  try {
    yield call(apiGetCollateral, action.payload);
  } catch (err) {
    yield put(actions.getCollateralFailed());
  }
}

function* getInvoiceCollateral(action) {
  try {
    yield call(apiGetInvoiceCollateralReport, action.payload);
  } catch (err) {
    yield put(actions.getCollateralFailed());
  }
}

export default function* collateralSaga() {
  yield all([
    fork(watchGetCollaterals),
    fork(watchGetCanceledCollaterals),
    fork(watchGetInvoiceCollateralReport),
  ]);
}

function apiGetCollateral(reqParams) {
  let startDate = reqParams.startDate ?? null;
  let endDate = reqParams.endDate ?? null;
  let organizationId =
    reqParams.organizationId ?? null;

  return API_GET("exchange-order/takasbank/deposit/search", {
    startDate,
    endDate,
    organizationId,
    page: reqParams?.page || 0,
    size: 10,
  });
}
function apiGetInvoiceCollateralReport(reqParams) {
  let startTerm = reqParams.startTerm ??  null;
  let endTerm = reqParams.endTerm ?? null;
  let organizationId =
    reqParams.organizationId ?? null;
  return API_GET("reconciliation/invoice-assurance-report", {
    startTerm,
    endTerm,
    organizationId,
    page: reqParams?.page || 0,
    size: 10,
  });
}
